import { inject, Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular/standalone';

@Injectable()
export class LoadingService
{
    private loading: any;
    private loadingController = inject(LoadingController);

    async show(message: string | null = null): Promise<void>
    {
        if (!this.loading)
        {
            if (message === null)
            {
                message = 'Loading...';
            }

            this.loading = await this.loadingController.create({
                message,
                animated: true,
                backdropDismiss: false,
                showBackdrop: true,
                keyboardClose: true,
                spinner: 'bubbles',
            });

            await this.loading.present();
        }
    }

    async hide(): Promise<void>
    {
        if (this.loading)
        {
            await this.loading.dismiss();
            this.loading = null;
        }
    }
}
